import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { endOfMonth, startOfMonth } from "date-fns";
import { AccountingReportContext } from "../AccountingReport.context";
import { useDrillDownUrl } from "../useDrillDownUrl";
import { ChildrenProps } from "../../../types";
import { TrialBalancePeriod } from "../../../common/contracts/accounting-reports";

interface Props extends ChildrenProps {
    accountCode: string;
    period: TrialBalancePeriod;
}

export const TrialBalanceTableDrillDown: React.FC<Props> = ({
    accountCode,
    period,
    children,
}) => {
    const { filters } = useContext(AccountingReportContext);
    const { entityId, classes, classFilterType } = filters;

    const path = useDrillDownUrl({
        startDate: startOfMonth(new Date(period.label)),
        endDate: endOfMonth(new Date(period.label)),
        entityId,
        accountCodes: [accountCode],
        classes,
        classFilterType,
    });
    return (
        <NavLink to={path} className="data-table__drill-down">
            {children}
        </NavLink>
    );
};
